module.exports = __webpack_public_path__ + "static/img/tj7.e840f57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj7.png
// module id = qX4E
// module chunks = 0